import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function LegalPage() {
  const { pageType } = useParams();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  const title = pageType === "privacy" ? "Privacy Policy" : "Terms of Use";

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/legal/${pageType}`);
        setContent(response.data.content);
      } catch {
        setContent("# Page Not Found\n\nThe requested page could not be loaded.");
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [pageType]);

  const renderMarkdown = (text) => {
    return text
      .split("\n")
      .map((line, i) => {
        if (line.startsWith("# ")) {
          return <h1 key={i} className="text-xl font-semibold text-ink tracking-tight mb-4 mt-6">{line.slice(2)}</h1>;
        }
        if (line.startsWith("## ")) {
          return <h2 key={i} className="text-lg font-semibold text-ink mb-2 mt-5">{line.slice(3)}</h2>;
        }
        if (line.startsWith("- ")) {
          const html = line.slice(2).replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
          return <li key={i} className="ml-4 text-ink-muted mb-1 list-disc" dangerouslySetInnerHTML={{ __html: html }} />;
        }
        if (line.trim() === "") {
          return <div key={i} className="h-2" />;
        }
        const html = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        return <p key={i} className="text-ink-muted mb-2 leading-relaxed" dangerouslySetInnerHTML={{ __html: html }} />;
      });
  };

  return (
    <div className="min-h-screen bg-app">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-accent hover:text-ink mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="bg-white rounded-xl shadow-sm border border-line p-6 sm:p-8">
          {loading ? (
            <div className="text-center py-12 text-ink-soft">Loading {title}...</div>
          ) : (
            <div data-testid={`legal-${pageType}-content`}>
              {renderMarkdown(content)}
            </div>
          )}
        </div>

        <div className="text-center mt-6">
          <p className="text-xs text-ink-soft">© 2026 Golf Eclectic</p>
        </div>
      </div>
    </div>
  );
}
